import axios from "axios";
import endpointNames from "../configs/serverUrls";

const baseUrl = endpointNames.beneficiary;
const base2Url = endpointNames.beneficiaries;
const base = endpointNames.dependent;
const base2 = endpointNames.dependents;

// get User Token
let user = JSON.parse(localStorage.getItem('user'));
//gets token from localStorage
let token = JSON.parse(localStorage.getItem('token'));

const config = {
    headers: {Authorization: `Bearer ${token}`}
};

//add
const addBeneficiary = async (request,policyId) => {
    let user = JSON.parse(localStorage.getItem('user'));
    console.log(request,policyId)
    let response;
    let data = {
        "name": request.name,
        "surname": request.surname,
        "relationship": request.relationship,
        "id_number": request.id_number,
        "gender": request.gender,
        "date_of_birth": request.date_of_birth,
        "mobile_number": request.mobile_number,
        "policy_id": policyId,
        "user": user.name
    }
    console.log(data);
    await axios.post(baseUrl,data, config)
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}

//add
const addDependent = async (request,policyId) => {
    console.log(request,policyId)
    let response;
    let data = {
        name: request.name,
        surname: request.surname,
        person_type: request.person_type,
        date_of_birth: request.date_of_birth,
        id_number: request.id_number,
        mobile_number: request.mobile_number,
        policy_id: policyId,
        gender: request.gender,
        premium: request.premium,
        relationship: request.relationship,
        user: user.name
    }
    console.log(data);
    await axios.post(base,data, config)
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}

//delete
const deleteBeneficiary = async (request) => {
    let response;
    await axios.delete(baseUrl+'/'+request.id, config)
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}

const deleteDependent = async (request) => {
    let response;
    await axios.delete(base +'/'+request.id, config)
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}

//update
const updateBeneficiary = async (request) => {
    let response;
    let data = {
        "name": request.name,
        "surname": request.surname,
        "relationship": request.relationship,
        "id_number": request.id_number,
        "gender": request.gender,
        "date_of_birth": request.date_of_birth,
        "mobile_number": request.mobile_number,
        "policy_id": request.policy_id,
        "user": user.name
    }

    console.log("id: ", request);
    await axios.put(baseUrl + '/update/' + request.id, data, config)
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}

//update
const updateDependent = async (request) => {
    let response;
    console.log("request: " + request)
    let data = {
        "name": request.name,
        "surname": request.surname,
        "relationship": request.relationship,
        "id_number": request.id_number,
        "gender": request.gender,
        "date_of_birth": request.date_of_birth,
        "mobile_number": request.mobile_number,
        "policy_id": request.policy_id,
        "premium": request.premium,
        "user_id": user.id
    }

    console.log(request);
    await axios.put(base + '/update/' + request.id, data, config)
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}

//get beneficiaries
const getBeneficiaries = async (policyId) => {
    let response;
    await axios.get(base2Url+policyId, config)
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}

//get dependencies
const getDependencies = async (policyId) => {
    let response;
    await axios.get(base2+policyId, config)
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}


export default {
    addBeneficiary,updateBeneficiary,deleteBeneficiary,getBeneficiaries,getDependencies,
    addDependent, updateDependent, deleteDependent
}
